
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsConnectEdcBankGrid extends Serenity.EntityGrid<PsConnectEdcBankRow, any> {
        protected getColumnsKey() { return PsConnectEdcBankColumns.columnsKey; }
        protected getDialogType() { return PsConnectEdcBankDialog; }
        protected getIdProperty() { return PsConnectEdcBankRow.idProperty; }
        protected getInsertPermission() { return PsConnectEdcBankRow.insertPermission; }
        protected getLocalTextPrefix() { return PsConnectEdcBankRow.localTextPrefix; }
        protected getService() { return PsConnectEdcBankService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}